import { render, staticRenderFns } from "./CustomOccupationKanban.vue?vue&type=template&id=4a93e3ba&scoped=true&"
import script from "./CustomOccupationKanban.vue?vue&type=script&lang=js&"
export * from "./CustomOccupationKanban.vue?vue&type=script&lang=js&"
import style0 from "./CustomOccupationKanban.vue?vue&type=style&index=0&id=4a93e3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a93e3ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {KanbanBoard: require('/workspace/components/KanbanBoard/KanbanBoard.vue').default})
